import {
  addErrorHandler,
  ensureJQuerySupport,
  registerApplication,
  start,
} from 'single-spa';
import jQuery from 'jquery';
import { exceptionHandler } from './config/exception-handler.js';
import { redirectToMobileAppDownloadOrWebApp } from './components/shared/react/utils/mobile-app';
import '@/content/styles/site.scss';
import '@redlist/react-ui/lib/assets/css/tailwind.css';

// https://single-spa.js.org/docs/configuration/#using-configuration-object

addErrorHandler(exceptionHandler);
ensureJQuerySupport(jQuery);

window.addEventListener('single-spa:routing-event', () => {
  // If url starts with https://mobileapp. then redirect to mobile app
  if (window.location.href.startsWith(process.env.APP_MOBILE)) {
    redirectToMobileAppDownloadOrWebApp();
  }
});

const routes = {
  'angular-forms': ['/forms/submit'],
  'react-lubemanagement': ['/lubrication-management'],
  'react-publicportal': ['/r2', '/inspections'],
  'react-signup': ['/sign-up'],
  'react-resetpassword': ['/reset-password', '/users/user-activation', '/enforce-password-change'],
  'react-jitrequest': ['/jit-request'],
  'react-fileview': ['/file-view'],
};

registerApplication({
  name: '@redlist/angular-main',
  app: () => import('./apps/angular-main.js'),
  activeWhen: [location => !Object.values(routes).flat().some(route => location.pathname.startsWith(route))],
});

registerApplication({
  name: '@redlist/angular-forms',
  app: () => import('./apps/angular-forms.js'),
  activeWhen: routes['angular-forms'],
});

registerApplication({
  name: '@redlist/react-lubemanagement',
  app: () => import('./apps/react-lubemanagement.js'),
  activeWhen: routes['react-lubemanagement'],
});

registerApplication({
  name: '@redlist/react-publicportal',
  app: () => import('./apps/react-publicportal.js'),
  activeWhen: routes['react-publicportal'],
});

registerApplication({
  name: '@redlist/react-signup',
  app: () => import('./apps/react-signup.tsx'),
  activeWhen: routes['react-signup'],
});

registerApplication({
  name: '@redlist/react-resetpassword',
  app: () => import('./apps/react-resetpassword.tsx'),
  activeWhen: routes['react-resetpassword'],
});

registerApplication({
  name: '@redlist/react-jitrequest',
  app: () => import('./apps/react-jitrequest.tsx'),
  activeWhen: routes['react-jitrequest'],
});

registerApplication({
  name: '@redlist/react-fileview',
  app: () => import('./apps/react-fileview.tsx'),
  activeWhen: routes['react-fileview'],
});

start();
